"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFirebaseURL = exports.getUserRequests = void 0;
var getUserRequests = function (userID, firebaseApp) { return __awaiter(void 0, void 0, void 0, function () {
    var get, Columns, HiddenColumns, mapped, finalColumns;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebaseApp
                    .firestore()
                    .collection("users/" + userID + "/requests")
                    .get()];
            case 1:
                get = _a.sent();
                Columns = new Set();
                HiddenColumns = new Set();
                mapped = get.docs
                    .map(function (d) { return d.data(); })
                    .map(function (obj) {
                    var results = {};
                    Object.entries(obj).forEach(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        if (typeof value === 'string' || typeof value === 'number') {
                            Columns.add(key);
                            results[key] = value;
                        }
                        else if (Array.isArray(value)) {
                            value.forEach(function (v) {
                                if (typeof v === 'object') {
                                    var _a = __read(Object.keys(v)
                                        .sort()
                                        .map(function (k) { return v[k]; }), 2), val = _a[0], k = _a[1];
                                    results[k] = val;
                                    HiddenColumns.add(k);
                                }
                                else {
                                    results[key] = JSON.stringify(value);
                                    HiddenColumns.add(key);
                                }
                            });
                        }
                        else {
                            results[key] = JSON.stringify(value);
                            HiddenColumns.add(key);
                        }
                    });
                    return results;
                });
                finalColumns = Array.from(Columns)
                    .sort()
                    .map(function (f) {
                    return f === 'created_at'
                        ? {
                            title: 'Datum',
                            field: f,
                            render: function (r) {
                                return new Date(r.created_at).toLocaleDateString() + " " + new Date(r.created_at).toLocaleTimeString();
                            },
                            defaultSort: 'desc'
                        }
                        : {
                            title: f,
                            field: f
                        };
                })
                    .concat(Array.from(HiddenColumns)
                    .sort()
                    .map(function (f) { return ({
                    title: f,
                    field: f,
                    hidden: true,
                    render: undefined
                }); }));
                return [2 /*return*/, { data: mapped, columns: finalColumns }];
        }
    });
}); };
exports.getUserRequests = getUserRequests;
var downloadFirebaseURL = function (url, name) {
    var xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function (event) {
        var blob = xhr.response;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.target = '_blank';
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    xhr.open('GET', url);
    xhr.send();
};
exports.downloadFirebaseURL = downloadFirebaseURL;
//# sourceMappingURL=helpers.js.map